import CleaningServicesTwoToneIcon from '@mui/icons-material/CleaningServicesTwoTone';
import { TextField } from "@mui/material";
import { FC, useState } from "react";
import { ImageItemsI } from "../models/media";
import { handleChangeFile } from "../utils/files";
import CustomInputFile from "./Custom/InputFile";
import { mediaFilter } from '../utils/image';

interface Props {
    value: ImageItemsI
    onChange?: (e: ImageItemsI) => void,
    title?: string
}

const SelectMedias: FC<Props> = ({ value, onChange, title }) => {

    const [images, setImages] = useState(value)

    const sortedImages = Object.keys(images).sort((a, b) => images[a].orden - images[b].orden);


    const onChangeImage = (e: React.ChangeEvent<HTMLInputElement>, id: string) => {
        const data = {
            [id]: {
                ...images[id],
                media: handleChangeFile(e),
            }
        }

        setImages(prev => ({
            ...prev,
            ...data
        }))
        onChange && onChange({
            ...images,
            ...data
        })
    }

    const clearImage = (id: string) => {
        const updatedImages = { ...images };
        updatedImages[id].imagen = "";
        updatedImages[id].path_imagen = "";
        setImages(updatedImages);
    };

    

    return (
        <div style={{
            background: 'white'
        }} className="contenedor">
            <h2>{title}</h2>
            <div style={{ display: 'flex', flexWrap: 'wrap' }}>
                {
                    sortedImages.map(k => {
                    return <div key={k}>

                        <CustomInputFile
                            label="Imagen (1440 x 720px)" key={k}
                            onChange={e => onChangeImage(e, k)}
                            type='videoimg'
                            img={mediaFilter({path:images[k].path_imagen})}
                        />

                        <CleaningServicesTwoToneIcon onClick={() => clearImage(k)} />

                    </div>
                })}
                </div>
        </div>
    )
}

export default SelectMedias